import sportCourtReduxWorker from "../../store/workers/SportCourtReduxWorker";

export function appInfoLoader() {
  sportCourtReduxWorker.updateSportCourtOnRedux();
}
